import rxNumberValidation from './rxNumberValidation';
import lastNameValidation from './lastNameValidation';
import nameOnCardValidation from './nameOnCardValidation';
import ccNumAndCvcValidation from './ccNumAndCvcValidation';
import ccExpirationValidation from './ccExpirationValidation';
import {
  emailValidation,
  emailValidationOrderConf,
  phoneValidation,
  street1Validation,
  cityValidation,
  stateValidation,
  postalCodeValidation,
} from './addressValidations';

export const rxLookupFormValidations = values => ({
  ...rxNumberValidation(values.rxNumber),
  ...lastNameValidation(values.lastName),
});

export const orderConfFormValidations = values => ({
  ...emailValidationOrderConf(values.emailAddress),
});

const customerValidations = customer => ({
  ...emailValidation(customer.emailAddress),
  ...phoneValidation(customer.phoneNumber),
  billingAddress: {
    ...street1Validation(customer.billingAddress.street1),
    ...cityValidation(customer.billingAddress.city),
    ...postalCodeValidation(customer.billingAddress.postalCode),
    ...stateValidation(customer.billingAddress.state),
  },
  shippingAddress: {
    ...street1Validation(customer.shippingAddress.street1),
    ...cityValidation(customer.shippingAddress.city),
    ...postalCodeValidation(customer.shippingAddress.postalCode),
    ...stateValidation(customer.shippingAddress.state),
  },
});

const paymentValidations = defaultPaymentOption => ({
  ...ccNumAndCvcValidation(
    defaultPaymentOption.creditCardNumber,
    defaultPaymentOption.ccSecurityCode
  ),
  ...nameOnCardValidation(defaultPaymentOption.name),
  ...ccExpirationValidation(
    defaultPaymentOption.expirationMonth,
    defaultPaymentOption.expirationYear
  ),
});

export const OrderSubmissionFormValidations = values => {
  const foo = {
    defaultPaymentOption: paymentValidations(values.defaultPaymentOption),
    customer: customerValidations(values.customer),
  };
  return foo;
};



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/index.js